
import { services, EventBus } from '../../Services/Services';
import Vue from 'vue';

export default {

    data: function () {
        return {

            /** The quantity of this product  */
            quantity: 1,

            /** The selected main product */
            selectedMainProduct: {},

            /** The product items of this product */
            productExtras: {},

            /** A value indicating wheter all the items are valid or not */
            isTotalValid : true
        };
    },

    computed: {
        isValid: function () {
            return this.isTotalValid;
        }
    },

    methods: {
        /**
         * Toggle collapse Click handler 
         * @param {object} event - the event
         */
        toggleCollapse: function (event) {
            this.collapsed = !this.collapsed;

            // when collapsed, reset the preperation methods quantity to 0
            if (this.collapsed) {

                for (var key in this.productExtras) {
                    this.productExtras[key] = {};
                }

                this._calculateDishPrice();
            }
        },

        /**
         * Get the allergy
         * @param {number} id - the allergy id
         * @returns {object} - the requested allergy
         */
        getAllergy: function (id) {
            return services.getAllergy(id);
        },

        /**
         * Returns the quantity of the requested product. Parent Child relation is required.
         * @param {Number} extraId the id of the product
         * @param {Number} parentId the id of the parent
         * @returns {Number} the quantity
         */
        extraQuantity: function (extraId, parentId) {
            if (parentId) {
                if (this.productExtras[parentId] && this.productExtras[parentId].children && this.productExtras[parentId].children[extraId]) {
                    return this.productExtras[parentId].children[extraId].quantity;
                }
            } else {
                if (this.productExtras[extraId]) {
                    return this.productExtras[extraId].quantity;
                }
            }

            return 0;
        },

        /**
         * quanty changed event handler 
         * @param {number} quantity - the quantity
         */
        quantityChanged: function (quantity) {
            this.quantity = quantity;
            this._calculateDishPrice();
        },

        /**
         * Preperation method quantity changed handler
         * @param {any} event - the event {productId : number, quantity : number, selectionType : 'radio|checkbox'}
         * @param {any} parentId - the  parentId
         * @param {any} radioGroup - the radioGroup
         * @param {number} displayOrder - the displayorder
         */
        extraQuantityChanged: function (event, parentId, radioGroup, displayOrder) {
            let oldSelection;

            // radio button behavior
            if (event.selectionType === 'radio') {

                if (event.extraQuantity <= 0) {
                    return;
                }

                if (this.productExtraRadioId[radioGroup] !== event.extraId) {
                    if (this.productExtraRadioId[radioGroup] > 0) {
                        if (parentId) {
                            // remove old extra from array.
                            Vue.delete(this.productExtras[parentId].children, this.productExtraRadioId[radioGroup]);
                        } else {
                            // remove old extra from array.
                            oldSelection = this.productExtras[this.productExtraRadioId[radioGroup]];
                            Vue.delete(this.productExtras, this.productExtraRadioId[radioGroup]);
                        }
                    }
                    this.productExtraRadioId[radioGroup] = event.extraId;
                }

                if (!parentId) {
                    // responsivenes requires this construction (delete and set)
                    Vue.delete(this.selectedMainProduct, radioGroup);
                    this.selectedMainProduct[radioGroup] = [services.getProductExtra(event.extraId)];
                    // Vue.set(this.selectedMainProduct, radioGroup, [services.getProductExtra(event.extraId)]);
                }
            }
            // checkbox or else behavior
            else {
                if (!parentId) {
                    if (event.extraQuantity <= 0) {
                        if (this.selectedMainProduct[radioGroup]) {
                            var index = -1;
                            this.selectedMainProduct[radioGroup].some(function (el, i) { if (el.id == event.extraId) { index = i; return true; } });

                            if (index >= 0) {
                                this.selectedMainProduct[radioGroup].splice(index, 1);
                            }
                        }
                    } else {
                        if (!this.selectedMainProduct[radioGroup]) {
                            this.selectedMainProduct[radioGroup] = [services.getProductExtra(event.extraId)];
                        } else {
                            this.selectedMainProduct[radioGroup].push(services.getProductExtra(event.extraId));
                        }
                    }
                }
            }

            var quantityModel;
            var key = parentId ? parentId : event.extraId;
            quantityModel = this.productExtras[key];

            if (parentId) {
                // quantity changed for one of the preperation methods (saus) of parentId

                // check parent model
                if (!quantityModel) {
                    // should not be posible
                    quantityModel = {
                        quantity: 1,
                        children: {},
                        displayOrder: displayOrder
                    };
                }

                var childQuantityModel = quantityModel.children[event.extraId];

                if (!childQuantityModel) {
                    childQuantityModel = {
                        quantity: event.extraQuantity,
                        children: {},
                        displayOrder: displayOrder
                    };
                }
                childQuantityModel.quantity = event.extraQuantity;

                Vue.set(quantityModel.children, event.extraId, childQuantityModel);

            } else {
                // quantity changed for the main product (patat)

                if (!quantityModel) {
                    quantityModel = {
                        quantity: event.extraQuantity,
                        children: {},
                        displayOrder: displayOrder
                    };
                }

                var childpreperationGroups = ['Product_preparationMethods', 'extra'];
                var childPreperationGroup;

                // set default child selection.
                for (var index in childpreperationGroups) {
                    childPreperationGroup = childpreperationGroups[index];

                    if (this.selectedMainProduct[radioGroup].length && this.selectedMainProduct[radioGroup][0].content[childPreperationGroup]) {

                        // try previous selected prepmethods.
                        let foundPreselected = false;
                        if (oldSelection && oldSelection.children) {

                            this.selectedMainProduct[radioGroup][0].content[childPreperationGroup].forEach(a => {
                                let childProduct = services.getProductExtra(a);

                                for (let key in oldSelection.children) {
                                    if (childProduct.id == key) {
                                        foundPreselected = true;
                                        quantityModel.children[a] = {
                                            quantity: 1,
                                            children: {},
                                            displayOrder: oldSelection.children[key].displayOrder
                                        };

                                        switch (childPreperationGroup) {
                                            case "Product_preparationMethods":
                                                if (this.selectedMainProduct[radioGroup][0].content.preperationMethodsSelectType == 'radio')
                                                    this.productExtraRadioId[radioGroup + '_' + event.extraId] = a;
                                                break;
                                            case "extra":
                                                if (this.selectedMainProduct[radioGroup][0].content.extraSelectType == 'radio')
                                                    this.productExtraRadioId[radioGroup + '_2_' + event.extraId] = a;
                                        }
                                    }
                                }
                            });

                            if (!foundPreselected) {
                                this.selectedMainProduct[radioGroup][0].content[childPreperationGroup].forEach(a => {
                                    let childProduct = services.getProductExtra(a);

                                    if (childProduct.content['preselected_' + this.selectedMainProduct[radioGroup][0].id]) {
                                        quantityModel.children[a] = {
                                            quantity: 1,
                                            children: {},
                                            displayOrder: 0
                                        };

                                        switch (childPreperationGroup) {
                                            case "Product_preparationMethods":
                                                if (this.selectedMainProduct[radioGroup][0].content.preperationMethodsSelectType == 'radio')
                                                    this.productExtraRadioId[radioGroup + '_' + event.extraId] = a;
                                                break;
                                            case "extra":
                                                if (this.selectedMainProduct[radioGroup][0].content.extraSelectType == 'radio')
                                                    this.productExtraRadioId[radioGroup + '_2_' + event.extraId] = a;
                                        }
                                    }
                                });
                            }
                        }
                    }
                }

                quantityModel.quantity = event.extraQuantity;
            }

            Vue.set(this.productExtras, key, quantityModel);

            oldSelection = null;

            // recalculate total
            this._calculateAllergyAdditions();
            this._calculateDishPrice();
        },

        // private function
        _calculateAllergyAdditions: function () {
            var that = this;

            // only add addition allergies, but do check if already present in main product allergies, don't add if present.
            that.allergyAdditions = [];

            function recalculate(extras) {
                // recalculate allergy total
                for (var key in extras) {
                    var extra = extras[key];
                    if (extra) {
                        if (extra.quantity > 0) {
                            let prepMethodProduct = services.getProductExtra(key);

                            // get allergies and loop to add to total, merge if needed
                            if (prepMethodProduct.content.allergenen) {
                                prepMethodProduct.content.allergenen.forEach(function (allergyId) {
                                    if (that.allergyAdditions.indexOf(allergyId) === -1
                                        && (!that.product.content.allergenen || that.product.content.allergenen.indexOf(allergyId) === -1)) {
                                        that.allergyAdditions.push(allergyId);
                                    }
                                });
                            }
                        }

                        if (extra.children) {
                            recalculate(extra.children);
                        }
                    }
                }
            }
            recalculate(this.productExtras);
        },

        _calculateDishPrice: function () {
            var _this = this;

            this.totalPrice = services.getPrice(this.product, this.quantity);

            function recalculate(extras) {
                // recalculate totals
                for (var key in extras) {
                    var extra = extras[key];
                    if (extra) {
                        if (extra.quantity > 0) {
                            var prepMethodProduct = services.getProductExtra(key);

                            _this.totalPrice += services.getPrice(prepMethodProduct, extra.quantity * _this.quantity);
                        }

                        if (extra.children) {
                            recalculate(extra.children);
                        }
                    }
                }
            }

            recalculate(this.productExtras);
        },

        /**
         * Add to basket handler
         * @param {any} event - the event
         */
        addToBasket: function (event) {
            if (this.product.buyButtonDisabled) {
                return;
            }

            if (!this.isValid) {
                // dont close the window.
                event.stopPropagation();
                return;
            }

            // quantity
            this.quantity = Math.max(this.quantity, 1);

            // gather data for this dish
            let items = [];
            // main item.
            let item = {
                product: this.product, quantity: this.quantity, children: [] };
            items.push(item);

            function _addChildren(addonproducts, shoppingbagItem, parentQuantity) {
                // grandchildren
                for (let key in addonproducts) {
                    let extra = addonproducts[key];

                    if (extra.quantity > 0) {
                        var prepMethodProduct = services.getProductExtra(key);

                        //let prepItem = { product: prepMethodProduct, Quantity: (q * this.quantity) };
                        let prepItem = { product: prepMethodProduct, quantity: extra.quantity * parentQuantity, displayOrder: extra.displayOrder };
                        shoppingbagItem.children.push(prepItem);

                        if (extra.children) {
                            prepItem.children = [];
                            _addChildren(extra.children, prepItem, prepItem.quantity);
                        }
                    }
                }

                shoppingbagItem.children.sort(function (a, b) { return a.displayOrder - b.displayOrder; });
            }

            _addChildren(this.productExtras, item, item.quantity);
          
            // raise event, basket component is responsible for api interaction
            EventBus.$emit('add-to-basket', items);
        }
    }
};



// WEBPACK FOOTER //
// ./Vue/Src/Components/Mixins/orderItemMixin.js